module.exports = __webpack_public_path__ + "img/informativ-powered-by-circle-horizontal-creditdriver01.18a24833.png";